import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mainApi } from '@/lib/api';
import { QUERY_KEYS } from '@/lib/constants';
import { stanNotify } from '@/lib/stanNotify';
import type { ReorderPagesPayload } from '../../types';

export function useReorderFunnelPages(storeId: number) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (pages: ReorderPagesPayload[]) => {
            await mainApi.patch(`v1/stores/${storeId}/pages/order`, pages);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FUNNELS, 'detail', storeId] });
        },
        onError: () => {
            stanNotify({
                type: 'error',
                title: 'Oops!',
                text: 'Failed to reorder pages. Please try again.',
                duration: 2000,
            });
        },
    });
}
